<template>
  <div class="settings_line">
    <p class="subtitle">Room</p>

    <dropDown
        :default_item="currentItem"
        :options="options"
        @setDevice="getCapacity"
    ></dropDown>
  </div>
</template>

<script>
import dropDown from "@/components/dropDown.vue";

export default {
  name: "RoomSettings",

  data() {
    return {
      capacityInput: "",
      /*        this.$store.state.meeting.roomData.capacity +
              (this.$store.state.meeting.roomData.capacity == 3
                ? " (small)"
                : " (big)"),*/
      options: [
        {
          label: "3 (small)",
          deviceId: 3,
        },

        {
          label: "200 (big)",
          deviceId: 200,
        },
      ],
    };
  },

  components: {
    dropDown,
  },

  computed: {
    roomCapacity() {
      return this.$store.state.meeting.meeting?.capacity
    },
    currentItem() {
      return this.roomCapacity ? this.options.find(it => it.deviceId === this.roomCapacity).label : this.options[0].label
    }
  },

  methods: {
    async getCapacity(setDevice) {
      try {
        this.$store.commit("showModal", ["changing_room_capacity", false])
        await this.$store.dispatch("setCapacity", parseInt(setDevice));
        this.$store.commit("showModal", ["room_changed_modal", false]);
      } catch (e) {
        this.$store.dispatch("onError", e);
      }
    },
  },
};
</script>

<style scoped>
.settings_line {
  margin-bottom: 32px;
}
</style>
